import { useEffect, useState, useRef, useDebugValue } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import LayoutOne from '../../layouts/LayoutOne';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../axios';
import { addCart, deleteCart, getCartProducts } from '../../store/actions/cart-actions';
import Swal from 'sweetalert2';
import config from '../../config';
import { applyCoupon, deleteFromCart } from '../../store/slices/cart-slice';
import cogoToast from 'cogo-toast';

const PaymentPage = () => {
  const key = config.razorpay.KEY;
  const location = useLocation()
  const paymentData = location.state?.payload
  const paymentAmountData = location.state?.paymentPayload

  console.log(paymentData, "paymentDatapaymentData")
  console.log(location, "locationlocation")
  const [activePaymentMethod, setActivePaymentMethod] = useState('card');
  const [paymentType, setPaymentType] = useState('full'); // 'full' or 'advance'
  const [cardDetails, setCardDetails] = useState({ number: '', expiry: '' });
  const [upiId, setUpiId] = useState('');
  const cardRef = useRef(null);
  const upiRef = useRef(null);
  const [cardHeight, setCardHeight] = useState(0);
  const [upiHeight, setUpiHeight] = useState(0);
  const { cartItems } = useSelector((state) => state.cart);
  const [cartTotalPrice, setCartTotalPrice] = useState(0);
  const { appliedCoupon, discountedTotal } = useSelector((state) => state.cart);
  const deliveryCost = useSelector((state) => state.settings.list[0]?.orderAmt) || 0;
  var discountedPrice;

  // Sample pricing data - replace with your actual data
  const pricingData = {
    cartTotalPrice: paymentAmountData?.cartTotalPrice,
    discount: paymentAmountData?.discount,
    deliveryCharges: paymentAmountData?.deliveryCharges
  };

  useEffect(() => {
    if (cardRef.current) setCardHeight(cardRef.current.scrollHeight);
    if (upiRef.current) setUpiHeight(upiRef.current.scrollHeight);
  }, []);

  const getSectionStyle = (isActive, maxHeight = 200) => ({
    maxHeight: isActive ? `${maxHeight}px` : '0',
    opacity: isActive ? 1 : 0,
    overflow: 'hidden',
    transition: 'all 0.4s ease',
  });

  const validateCard = () => {
    const { number, expiry } = cardDetails;
    const cardNumberValid = /^\d{16}$/.test(number.trim());
    const expiryValid = /^(0[1-9]|1[0-2])\/\d{2}$/.test(expiry.trim());
    if (!cardNumberValid) {
      cogoToast.error('Card number must be 16 digits.');
      return false;
    }

    if (!expiryValid) {
      cogoToast.error('Expiry must be in MM/YY format.');
      return false;
    }

    // Check if expiry is in the future
    const [month, year] = expiry.split('/');
    const expDate = new Date(`20${year}`, month); // the 1st of the month after expiration
    const now = new Date();
    if (expDate <= now) {
      cogoToast.error('Card is expired.');
      return false;
    }

    return true;
  };

  const validateUPI = () => {
    const upiPattern = /^[\w.-]+@[\w.-]+$/;
    if (!upiPattern.test(upiId.trim())) {
      alert('Enter a valid UPI ID (e.g., yourname@bank).');
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (activePaymentMethod === 'card') {
      if (validateCard()) {
        setActivePaymentMethod('');
      }
    } else if (activePaymentMethod === 'upi') {
      if (validateUPI()) {
        setActivePaymentMethod('');
      }
    } else {
      cogoToast.error('Please select a payment method.');
    }
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const FetchCart = async () => {
      try {
        await dispatch(getCartProducts());
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };

    FetchCart();
  }, [dispatch]);

  useEffect(() => {
    let total = 0;
    cartItems.forEach((item) => {
      const discountedPrice = item.price || item.cartPrice;
      total += discountedPrice * item.qty;
    });
    setCartTotalPrice(total);

    if (appliedCoupon) {
      dispatch(applyCoupon({ coupon: appliedCoupon, cartTotal: total }));
    }
  }, [cartItems, appliedCoupon, dispatch]);

  const path = useLocation();

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Calculate final amount based on payment type
  const calculateFinalAmount = () => {
    const baseAmount = pricingData.cartTotalPrice - (pricingData.discount || 0) + pricingData.deliveryCharges;
    if (paymentType === 'advance') {
      return deliveryCost * cartItems.length + pricingData.deliveryCharges;;
    }
    return baseAmount;
  };

  const handleRazorpayPayment = async () => {
    try {
      // Update paymentData with the selected payment amount
      const updatedPaymentData = {
        ...paymentData,
        cartTotal: calculateFinalAmount(),
        paymentType: paymentType
      };

      const res = await axiosInstance.post("user/create-order", updatedPaymentData);

      const { code, message, data } = res.data;
      if (code !== 1) {
        Swal.fire({
          title: 'Error!',
          text: message || 'Failed to create order.',
          icon: 'error',
        });
        return;
      }

      const isScriptLoaded = await loadRazorpayScript();
      if (!isScriptLoaded) {
        Swal.fire({
          icon: 'error',
          title: 'Internet Error!',
        });
        return;
      }

      const amountInPaise = parseInt(data.amount);

      const options = {
        key: key,
        amount: amountInPaise,
        currency: data.currency || 'INR',
        name: data.name || 'Your Company Name',
        description: data.description || 'Payment for your order',
        order_id: data.orderId,
        prefill: {
          ...data.prefill,
          "method": activePaymentMethod,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axiosInstance.post('/user/verify', {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              dbOrderId: data.dbOrderId,
            });

            const verificationResult = verificationResponse.data.data;

            if (verificationResult) {
              Swal.fire({
                icon: 'success',
                title: 'Payment Successful!',
                text: 'Your order has been placed.',
              });

              dispatch(deleteCart(paymentData.cartIds[0]))

              navigate("/thankyou", {
                state: {
                  orderId: verificationResponse.data.orderId || data.dbOrderId,
                  paymentId: response.razorpay_payment_id
                },
                replace: true
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Payment Verification Failed',
                text: 'Please contact support.',
              });
            }
          } catch (error) {
            console.error('Payment verification error:', error);
            Swal.fire({
              icon: 'error',
              title: "Payment Related Error",
              text: 'Please contact support.',
            });
          }
        },
        theme: {
          color: '#28a745'
        },
        modal: {
          ondismiss: function () {
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error('Payment error:', error);
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
      });
    }
  };
  const handleDeleteFromCart = async (item) => {
    await dispatch(deleteFromCart(item.cartItemId));
    await dispatch(deleteCart(item.cartId));
    await dispatch(getCartProducts());
  };
  useEffect(() => {
    if (cartItems.length == 0) {
      cogoToast.success("Redirecting to Cart Page")
      setTimeout(() => { navigate("/cart") }, [1000])
    }
  }, [cartItems])
  return (
    <LayoutOne>
      <style jsx>{`
        .modern-card {
          border: none;
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
        }
        
        .payment-radio {
          position: relative;
        }
        
        .payment-radio input[type="radio"] {
          display: none;
        }
        
        .payment-radio label {
          display: block;
          padding: 20px 24px;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          position: relative;
          overflow: hidden;
        }
        
        .payment-radio label::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: -1;
        }
        
        .payment-radio input[type="radio"]:checked + label {
          border-color: #28a745;
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
        }
        
        .payment-radio input[type="radio"]:checked + label::before {
          opacity: 1;
        }
        
        .payment-radio label:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }
        
        .radio-circle {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 20px;
          height: 20px;
          border: 2px solid #dee2e6;
          border-radius: 50%;
          background: white;
          transition: all 0.3s ease;
        }
        
        .payment-radio input[type="radio"]:checked + label .radio-circle {
          border-color: white;
          background: white;
        }
        
        .payment-radio input[type="radio"]:checked + label .radio-circle::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #28a745;
        }
        
        .cart-item {
          padding: 16px;
          border-radius: 12px;
          background: #f8f9fa;
          margin-bottom: 12px;
          transition: all 0.3s ease;
        }
        
        .price-row {
          padding: 8px 0;
          border-bottom: 1px solid #e9ecef;
        }
        
        .price-row:last-child {
          border-bottom: none;
          font-weight: 600;
          font-size: 1.1rem;
        }
        
        .pay-button {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          border: none;
          border-radius: 12px;
          padding: 16px 32px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
        }
        
        .pay-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
          background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
        }
        
        .step-indicator {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
        }
        
        .step {
          display: flex;
          align-items: center;
          margin-right: 2rem;
        }
        
        .step-text {
          font-weight: 600;
          margin-right: 8px;
        }
        
        .step-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          transition: all 0.3s ease;
        }
      `}</style>
      <div className="container py-5" >
        <div className="step-indicator">
          <div className="step">
            <span className="step-text">DELIVERY DETAILS</span>
            <div
              className="step-dot"
              style={{
                backgroundColor: path.pathname === "/delivery-details" ? '#28a745' : '#6c757d',
              }}
            ></div>
          </div>
          <div className="step">
            <span className="step-text">REVIEW & PAYMENTS</span>
            <div
              className="step-dot"
              style={{
                backgroundColor: path.pathname === "/payment" ? '#28a745' : '#6c757d',
              }}
            ></div>
          </div>
        </div>

        <div className="row g-4">
          {/* Cart Items Section */}
          <div className="col-lg-7">
            <div className="modern-card" style={{ border: "2px solid gray", overflowY: 'scroll' }}>
              <div className="card-body p-4" >
                <h4 className="card-title mb-4 d-flex align-items-center">
                  <i className="fas fa-shopping-cart me-2 text-success"></i>
                  Your Cart ({cartItems.length} items)
                </h4>

                <div style={{ maxHeight: "500px", paddingRight: "6px" }}>
                  {cartItems.map((item, index) => (
                    <div
                      key={index}
                      className="card mb-3 shadow-sm"
                      style={{ borderRadius: "12px", overflow: "hidden" }}
                    >
                      <div className="row g-0 align-items-center p-2">
                        {/* Product Image */}
                        <div className="col-auto">
                          <img
                            src={item?.images?.[0]?.src || item?.seriesImages?.[0]?.src}
                            alt={item.name}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "contain",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              backgroundColor: "#f8f9fa",
                            }}
                            className="img-fluid"
                          />
                        </div>

                        {/* Product Details */}
                        <div className="col ps-3 pe-2">
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 className="fw-bold mb-1">
                                {item.name}{" "}
                                {item.refurbished && (
                                  <span className="badge bg-warning text-dark ms-1">Refurbished</span>
                                )}
                              </h6>
                              <small className="text-muted">Qty: {item.qty}</small>
                              <div className="text-success fw-bold mt-1">
                                ₹{item.price?.toLocaleString()}
                              </div>
                            </div>

                            {/* Remove Button */}
                            <button
                              className="btn btn-sm btn-outline-danger"
                              title="Remove from cart"
                              onClick={() => handleDeleteFromCart(item)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>

          {/* Payment Section */}
          <div className="col-lg-5" >
            <div className="modern-card" style={{ border: "2px solid gray" }}>
              <div className="card-body p-4">
                <h4 className="card-title mb-4 d-flex align-items-center">
                  <i className="fas fa-credit-card me-2 text-success"></i>
                  Payment Details
                </h4>

                {/* Payment Type Selection */}
                <div className="mb-4">
                  <h6 className="mb-3">Select Payment Type</h6>

                  <div className="payment-radio mb-3">
                    <input
                      type="radio"
                      id="full-payment"
                      name="paymentType"
                      value="full"
                      checked={paymentType === 'full'}
                      onChange={(e) => setPaymentType(e.target.value)}
                    />
                    <label htmlFor="full-payment">
                      <div className="radio-circle"></div>
                      <div>
                        <h6 className="mb-1" style={{ color: paymentType === 'full' ? "white" : "black" }}>Full Payment</h6>
                        <p className="mb-0 opacity-75" style={{ color: paymentType === 'full' ? "white" : "black" }}>Pay the complete amount now</p>
                      </div>
                    </label>
                  </div>

                  <div className="payment-radio">
                    <input
                      type="radio"
                      id="advance-payment"
                      name="paymentType"
                      value="advance"
                      checked={paymentType === 'advance'}
                      onChange={(e) => setPaymentType(e.target.value)}
                    />
                    <label htmlFor="advance-payment">
                      <div className="radio-circle"></div>
                      <div>
                        <h6 className="mb-1" style={{ color: paymentType === 'advance' ? "white" : "black" }}>Advance Payment</h6>
                        <p className="mb-0 opacity-75" style={{ color: paymentType === 'advance' ? "white" : "black" }}>Pay ₹{(deliveryCost * cartItems.length).toLocaleString()} now, rest on delivery</p>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Price Breakdown */}
                <div className="mb-4">
                  <div className="price-row d-flex justify-content-between">
                    <span>Cart Total</span>
                    <span>₹{paymentType == "advance" ? deliveryCost * cartItems?.length : pricingData?.cartTotalPrice}</span>
                  </div>

                  {pricingData.discount > 0 && (
                    <div className="price-row d-flex justify-content-between text-success">
                      <span>Discount</span>
                      <span>-₹{pricingData.discount.toLocaleString()}</span>
                    </div>
                  )}

                  <div className="price-row d-flex justify-content-between">
                    <span>Delivery Charges</span>
                    <span>₹{pricingData.deliveryCharges.toLocaleString()}</span>
                  </div>

                  <div className="price-row d-flex justify-content-between">
                    <span>Amount to Pay</span>
                    <span className="text-success">₹{calculateFinalAmount().toLocaleString()}</span>
                  </div>
                </div>

                {/* {paymentType === 'advance' && (
                  <div className="alert alert-info mb-4">
                    <i className="fas fa-info-circle me-2"></i>
                    <small>
                      Remaining amount: ₹{((pricingData.cartTotalPrice - pricingData.discount + pricingData.deliveryCharges) - (deliveryCost * cartItems.length)).toLocaleString()} will be collected on delivery.
                    </small>
                  </div>
                )} */}

                <button
                  className="pay-button w-100"
                  onClick={handleRazorpayPayment}
                >
                  <i className="fas fa-lock me-2"></i>
                  Pay ₹{calculateFinalAmount().toLocaleString()} Securely
                </button>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    <i className="fas fa-shield-alt me-1"></i>
                    Your payment information is secure and encrypted
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </LayoutOne >
  );
};

export default PaymentPage;